import React, {FC, useState} from "react";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import {useAppDispatch} from "../../common/hook";
import {shortWeekdayLabels} from "../pages/stats/status-calendar";


interface ICutCalendarProps {
    onClose: () => void;
    onDateSelected: (date: string) => void;
}


export const CutCalendar: FC<ICutCalendarProps> = ({ onClose, onDateSelected }) => {
    const [date, setDate] = useState<Date>(new Date());
    const dispatch = useAppDispatch();

    const onDateChange = (value: any) => {
        const day = value.getDate();
        const month = value.getMonth() + 1;
        const year = value.getFullYear();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        onDateSelected(formattedDate);
        onClose();
    };

    return (
        <div className="calendar-cup">
            <Calendar
                locale="ru"
                onChange={onDateChange}
                value={date}
                view="month"
                formatShortWeekday={(locale, date) =>
                    shortWeekdayLabels.weekdayShort[date.getDay()]
                }
                formatMonth={(locale, date) =>
                    new Intl.DateTimeFormat(locale, { month: "short" }).format(date)
                }
                calendarType="ISO 8601"
            />
        </div>
    );
};
